export default __webpack_public_path__ + "static/media/sign.5a9305ea.png";